// Workstream B — Obligations / Cost-Recovery ledger query-key factory. Per the
// stale-after-save convention, queryKey array literals live ONLY in *Keys
// files; reads register under these keys.

import type { CostRecoveryLedgerParams } from "@/api/portfolioAdmin/obligationLedgerApi";

export const obligationLedgerKeys = {
  loan: (loanId: string) =>
    ["portfolio-admin", "loan", loanId, "obligations"] as const,
  crossLoan: (params?: CostRecoveryLedgerParams) =>
    ["portfolio-admin", "cost-recovery", params ?? {}] as const,
  /** Prefix covering every filtered cross-loan variant — invalidate by this
   *  so all `crossLoan(params)` reads refresh. */
  crossLoanPrefix: () => ["portfolio-admin", "cost-recovery"] as const,
  // PR-6 Explain Engine.
  detail: (loanId: string, obligationId: string) =>
    ["portfolio-admin", "loan", loanId, "obligations", obligationId, "detail"] as const,
  comparison: (loanId: string) =>
    ["portfolio-admin", "loan", loanId, "obligations", "comparison"] as const,
};
